import { Icon } from 'react-feather'
import { ActionButton } from './FilterActionButton.style'

interface FIlterActionButtonProps {
    icon: JSX.Element | Icon
    label: string
    onClick: () => void
}

export const FilterActionButton = ({ icon, label, onClick }: FIlterActionButtonProps) => (
  <ActionButton onClick={onClick}>
    {icon}{label}
  </ActionButton>
)
